import React, { useState, useEffect  } from "react";
import { Container, Label, Input, FormGroup} from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Loading } from '../../../share/loading'
import * as Yup from 'yup'
import '../../../share/form.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from 'sweetalert2'
import 'react-datepicker/dist/react-datepicker.css'

export function DetailInnovationPersonTrainAndExpectedComponent () {
    const[searchParams] = useSearchParams();
    const supportInnovationId = searchParams.get("req")
    // console.log("supportInnovationId", supportInnovationId)
    const [data, setData] = useState({})

    // let status = searchParams.get("status");
    const navigate = useNavigate(); 
    const [loading, setLoading] = useState(false);
   
    const initialValues = {
        supportInnovationId : supportInnovationId,
        costRemark:"",
        benefitRemark:"",
        costCheckbox : [],
        benefitCheckbox : [],
    };
    const checkPreviousPage = () => {
        return navigate(`/supporting/Form/DetailInnovationCourse?req=${supportInnovationId}&&status=${searchParams.get("status")}`)
        // return navigate(`/supporting/Form/DetailInnovationPersonTrainAndExpected?req=${supportInnovationId}&&status=${searchParams.get("status")}`)
    }

    useEffect(() => {
        async function getExpectedInnovation () {
            setLoading(true)
            let postData = new FormData();
            postData.append("supportInnovationId", supportInnovationId)
            try{
                let res = await fetch("api/Support/getExpectedInnovation/",{
                    method:"POST",
                    body:postData,
                })
                let resJson = await res.json();
                if(!resJson.dataenum.length){
                    searchParams.set("status", "0")
                }else {
                    resJson.dataenum.map((item) => {
                        item["supportInnovationId"] = searchParams.get("req")
                        
                        item.costCheckbox = item.costCheckbox.filter(data => data !== null);
                        item.benefitCheckbox = item.benefitCheckbox.filter(data => data !== null);
                        Object.keys(item).forEach((key) => {
                            if (item[key] === null) {
                              item[key] = "";
                            }
                        });
                        setData((prev) => {
                            return { ...prev, ...item };
                        });
                    })
                }

            } catch (e) {
                // console.log("err",e)
            } finally {
                setLoading(false);
            }
        }
        getExpectedInnovation()
    },[])

    // console.log(bahttext(8.00))

    const onSubmit = async(values) => {
        // console.log("values",values);
        try{
            let res = await fetch("/api/Support/saveSupportExpectedInnovation", {
                method: "POST",
                headers : { "Content-type" : "application/json"},
                body: JSON.stringify(values)
            });

            let resJson = await res.json();

            if (resJson.status === 1) {
                if(searchParams.get("status") === "0"){
                    Swal.fire({
                        icon:"success",
                        title:"บันทึกข้อมูลสำเร็จ",
                        text:"",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if(result.isConfirmed) {
                            navigate(`/supporting/Form/DetailInnovationPersonTrain?req=${searchParams.get("req")}&&status=${searchParams.get("status")}`)
                        }
                    })
                }else {
                    Swal.fire({
                        icon:"success",
                        title:"อัพเดทข้อมูลสำเร็จ",
                        text:"",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if(result.isConfirmed) {
                            navigate(`/supporting/Form/DetailInnovationPersonTrain?req=${searchParams.get("req")}&&status=${searchParams.get("status")}`)
                        }
                    })
                }
                
            } else {
                Swal.fire({
                    icon:"error",
                    title:"บันทึกข้อมูลไม่สำเร็จ",
                    text:`เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        }catch (e){
            // console.log(e)
        }
}

    const validationSchema = Yup.object().shape({
        costCheckbox:Yup.array().min(1,"กรุณาเลือกอย่างน้อย 1 ข้อ"),
        benefitCheckbox:Yup.array().min(1,"กรุณาเลือกอย่างน้อย 1 ข้อ"),
        costRemark:Yup.string(),
        benefitRemark:Yup.string(),
    })


    return (
        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            {!loading ? (
                <div className="form-border">
                    <Formik
                        initialValues={searchParams.get("status") === "0" ? initialValues: data}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                    {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange }) => {
                        // console.log("values",values)
                        return (

                            <Form className="p-5 mb-4">
                            
                            <Label className="mb-3 input-color">ผลที่คาดว่าจะได้รับจากการฝึกอบรม</Label>
                                
                                
                                {/* checkbox 1 */}
                                <FormGroup className="px-2">
                                    
                                    <p className="input-color">ลดต้นทุน <ErrorMessage name="costCheckbox">{(msg => <span className="text-danger">{msg}</span>)}</ErrorMessage></p>
                                    
                                    <div className="form-check">
                                        <Field type="checkbox" name="costCheckbox" value="01" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            ลดขั้นตอนการผลิตสินค้าหรือบริการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="costCheckbox" value="02" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            ลดเวลาในการทำงาน
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="costCheckbox" value="03" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            ลดการสูญเสีย
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="costCheckbox" value="04" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            ลดอุบัติเหตุหรือโรคที่เกิดจากการทำงาน
                                        </Label>
                                    </div>
                                    <FormGroup className="mt-3">
                                        <Label>คำอธิบาย</Label>
                                        <Field 
                                            name="costRemark"
                                            >
                                                {({field,form}) => (
                                                    <Input
                                                        type="text"
                                                        className="rounded-pill"
                                                        {...field}
                                                    />
                                                )}

                                        </Field>
                                    </FormGroup>
                                </FormGroup>
                                
                                {/* checkbox 2 */}
                                <FormGroup className="px-2">
                                    <p className="input-color">เพิ่มรายได้ <ErrorMessage name="benefitCheckbox">{(msg => <span className="text-danger">{msg}</span>)}</ErrorMessage></p>
                                    <div className="form-check">
                                        <Field type="checkbox" name="benefitCheckbox" value="01" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            เพิ่มผลผลิตสินค้าหรือบริการมากขึ้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="02" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สินค้าหรือบริการมีคุณภาพมากขึ้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="03" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label " >
                                            ลูกจ้างมีรายได้เพิ่มขึ้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="04" >
                                            {({field,form}) => (
                                                <Input 
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สถานประกอบกิจการมีรายได้มากขึ้น
                                        </Label>
                                    </div>
                                    <FormGroup className="mt-3">
                                        <Label>คำอธิบาย</Label>
                                        <Field 
                                            name="benefitRemark"
                                            >
                                                {({field,form}) => (
                                                    <Input
                                                        type="text"
                                                        className="rounded-pill"
                                                        {...field}
                                                    />
                                                )}

                                        </Field>
                                    </FormGroup>
                                    
                                </FormGroup>

                                <div className="mt-3 d-flex justify-content-between mt-4">
                                    <button type="button" onClick={checkPreviousPage} className="bg-primary text-white w-25 p-2 rounded-pill border-0">ย้อนกลับ</button>
                                    <button className="bg-primary text-white w-25 p-2 rounded-pill border-0" type="submit">ถัดไป</button>
                                </div>
                            </Form>
                        )
                    }}
                    </Formik>
                </div>
            ): ( 
                <Loading/>
            )}
            
        </Container>
        
    )
}